__turbopack_context__.v({
  "accordionSlideOverwrite": "resetPasswordContent-module-scss-module__FiKKvq__accordionSlideOverwrite",
  "fadeIn": "resetPasswordContent-module-scss-module__FiKKvq__fadeIn",
  "fadeOut": "resetPasswordContent-module-scss-module__FiKKvq__fadeOut",
  "footer": "resetPasswordContent-module-scss-module__FiKKvq__footer",
  "footerLink": "resetPasswordContent-module-scss-module__FiKKvq__footerLink",
  "form": "resetPasswordContent-module-scss-module__FiKKvq__form",
  "header": "resetPasswordContent-module-scss-module__FiKKvq__header",
  "infoCard": "resetPasswordContent-module-scss-module__FiKKvq__infoCard",
  "link": "resetPasswordContent-module-scss-module__FiKKvq__link",
  "main": "resetPasswordContent-module-scss-module__FiKKvq__main",
  "scaleIn": "resetPasswordContent-module-scss-module__FiKKvq__scaleIn",
  "scaleOut": "resetPasswordContent-module-scss-module__FiKKvq__scaleOut",
  "submitButton": "resetPasswordContent-module-scss-module__FiKKvq__submitButton",
  "subtitle": "resetPasswordContent-module-scss-module__FiKKvq__subtitle",
  "textField": "resetPasswordContent-module-scss-module__FiKKvq__textField",
  "title": "resetPasswordContent-module-scss-module__FiKKvq__title",
  "zoomIn": "resetPasswordContent-module-scss-module__FiKKvq__zoomIn",
  "zoomOut": "resetPasswordContent-module-scss-module__FiKKvq__zoomOut",
});
